/**
 * Normalize the near-arb API body into items plus the info-line fields.
 * Accepts the DTO itself, a JSON string, or a wrapper whose `data` holds the DTO.
 * A bare array is the regular markets list and is not treated as near-arb items.
 *
 * @param {*} responseData
 * @returns {{ items: Array, bookmakers: string[], minMargin: number|null }}
 */
export const normalizeNearArbPayload = (responseData) => {
  const empty = { items: [], bookmakers: [], minMargin: null };
  let payload = responseData;

  if (typeof payload === 'string') {
    try {
      payload = JSON.parse(payload);
    } catch (error) {
      return empty;
    }
  }

  if (Array.isArray(payload)) {
    return empty;
  }

  if (
    payload
    && payload.data
    && typeof payload.data === 'object'
    && !Array.isArray(payload.data)
    && (
      Array.isArray(payload.data.items)
      || payload.data.bookmakers !== undefined
      || payload.data.minMargin !== undefined
      || payload.data.min_margin !== undefined
    )
  ) {
    payload = payload.data;
  }

  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return empty;
  }

  const hasNearArbFields = Array.isArray(payload.items)
    || payload.bookmakers !== undefined
    || payload.minMargin !== undefined
    || payload.min_margin !== undefined;
  if (!hasNearArbFields) {
    return empty;
  }

  const items = Array.isArray(payload.items) ? payload.items : [];

  let bookmakers = payload.bookmakers;
  if (typeof bookmakers === 'string') {
    bookmakers = bookmakers.split(',').map((name) => name.trim()).filter(Boolean);
  }
  if (!Array.isArray(bookmakers)) {
    bookmakers = [];
  }

  const rawMargin = payload.minMargin ?? payload.min_margin;
  const minMargin = rawMargin === null || rawMargin === undefined || rawMargin === ''
    ? null
    : Number(rawMargin);

  return {
    items,
    bookmakers,
    minMargin: Number.isFinite(minMargin) ? minMargin : null,
  };
};
